// extracted by mini-css-extract-plugin
export default {"container":"RepatchFooter_container__ElWzy","linksContainer":"RepatchFooter_linksContainer__xX+Tm","link":"RepatchFooter_link__QrMwK"};